import React, { PropsWithChildren } from "react";

import * as Styled from "./HelperText.styles";
import { ReactComponent as Sparkle } from "../../assets/images/sparkle-emoji.svg";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  marginTop?: number;
  marginBottom?: number;
};

export const HelperText: React.FC<PropsWithChildren<Props>> = ({
  style,
  children,
  className,
  marginBottom,
  marginTop,
}): JSX.Element => {
  return (
    <Styled.HelperText
      style={style}
      className={className}
      $marginBottom={marginBottom}
      $marginTop={marginTop}
    >
      <div style={{ width: "2rem" }}>
        <Sparkle />
      </div>
      <span>{children}</span>
    </Styled.HelperText>
  );
};
